<template>
  <InfoCardComponent :buttonText="buttonText" @setForceToggle="setForceToggle">
    <template #title>
      <div class="avatar avatar-x1 me-2">
        <font-awesome-icon :icon="icon" class="text-secondary-emphasis" />
      </div>
      <div class="flex-1">{{ titleText }}</div>
    </template>
    <template #content>
      <slot></slot>
    </template>
  </InfoCardComponent>
</template>

<script setup lang="ts">
import InfoCardComponent from "./InfoCardComponent.vue";

withDefaults(
  defineProps<{
    icon?: string;
    titleText: string;
    buttonText?: string;
  }>(),
  { icon: "circle-info" }
);

const emit = defineEmits<{
  setForceToggle: [forceToggleCollapse: (value: boolean) => void];
}>();

const setForceToggle = (method: (value: boolean) => void) => {
  emit("setForceToggle", method);
};
</script>
